enum AgreementType {
  INITIAL_SCORE = 'INITIAL',
  COUNTING = 'COUNT',
  UNSCHEDULED_SCORE = 'UNSCHEDULED',
}

export default AgreementType;
